// Zentrale API-Konfiguration
// Diese Datei wird beim Build mit den korrekten URLs befüllt

// Basis-URLs aus Environment-Variablen oder Fallback zu localhost
const BASE_URL = process.env.REACT_APP_API_URL || '';
const AUTH_BASE = process.env.REACT_APP_AUTH_URL || '';
const INGEST_BASE = process.env.REACT_APP_INGEST_URL || '';
const DEDUP_BASE = process.env.REACT_APP_DEDUP_URL || '';

// Erkennung ob localhost (für lokale Entwicklung)
const isLocalhost = BASE_URL.includes('localhost') || BASE_URL.includes('127.0.0.1');

export const API_CONFIG = {
  // Main API (Port 3000)
  API_URL: BASE_URL,
  API_V1: `${BASE_URL}/api/v1`,

  // Auth Service (Port 3004)
  AUTH_URL: AUTH_BASE,

  // Ingest Service (Port 3002)
  INGEST_URL: INGEST_BASE,
  INGEST_API: `${INGEST_BASE}/api/ingest`,

  // Dedup Service (Port 3003)
  DEDUP_URL: DEDUP_BASE,
  DEDUP_API: `${DEDUP_BASE}/api/dedup`,

  // RabbitMQ Management
  RABBITMQ_URL: isLocalhost ? 'http://localhost:15672' : `${BASE_URL.replace(/:\d+$/, '')}/rabbitmq`,

  // Health Check URLs
  HEALTH: {
    API: `${BASE_URL}/health`,
    AUTH: `${AUTH_BASE}/health`,
    INGEST: `${INGEST_BASE}/health`,
    DEDUP: `${DEDUP_BASE}/health`,
    RABBITMQ: isLocalhost ? 'http://localhost:15672' : `${BASE_URL.replace(/:\d+$/, '')}/rabbitmq/`,
  }
};

// Helper-Funktionen für häufig genutzte Endpoints
export const getApiUrl = (path: string) => `${API_CONFIG.API_V1}${path}`;
export const getAuthUrl = (path: string) => `${API_CONFIG.AUTH_URL}${path}`;
export const getIngestUrl = (path: string) => `${API_CONFIG.INGEST_API}${path}`;
export const getDedupUrl = (path: string) => `${API_CONFIG.DEDUP_API}${path}`;

// Authenticated fetch helper - automatically adds JWT token from localStorage
// Bei 401 (Token abgelaufen) wird automatisch auf /login umgeleitet
export const authFetch = async (url: string, options: RequestInit = {}): Promise<Response> => {
  const token = localStorage.getItem('auth_token');

  const headers: HeadersInit = {
    ...options.headers,
  };

  if (token) {
    (headers as Record<string, string>)['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    localStorage.removeItem('auth_token');
    sessionStorage.setItem('session_expired', '1');
    window.location.href = '/login';
    return response;
  }

  return response;
};

export default API_CONFIG;
